/*global initPopupCloseFunction, initIsCompletedChangeListener, initPlannedCompletionDateChangeListener, handleStatusChange*/
/*eslint @typescript-eslint/no-explicit-any:0 */
/* TODO: replace any (object might work but currently not recommended due to typescript issue) */
import { initPlannedCompletionDateChangeListener, initIsCompletedChangeListener, handleStatusChange } from './finish-case-dialog';
import { initPopupCloseFunction } from './popup';
jQuery(function () {
    var history = $('.history').length > 0;
    if (!history) {
        return;
    }
    var logItemToggleBtn = $('.js-log-item-toggle');
    var logItemRemoveBtn = $('.js-log-item-remove-btn');
    var logItemEditBtn = $('.js-log-item-edit-btn');
    var removePopup = $('#history-remove-popup');
    logItemToggleBtn.on('click', function () {
        var btn = $(this);
        var logItem = btn.closest('.history__log-item');
        btn.toggleClass('expanded');
        logItem.find('.history__log-item-mobile-content').slideToggle();
    });
    logItemRemoveBtn.on('click', function () {
        var logItem = $(this).closest('.history__log-item');
        var itemId = logItem.attr('data-id');
        var itemType = logItem.attr('data-type');
        var completionDate = logItem.attr('data-completion-date');
        var stringType = $('.js-history-remove-type');
        switch (itemType) {
            case 'Inspection':
                stringType.text('kontrollen');
                break;
            case 'Maintenance':
                stringType.text('åtgärden');
                break;
            case 'Renovation':
                stringType.text('renoveringen');
                break;
            default:
                break;
        }
        removePopup.find('input[name="id"]').val(itemId);
        removePopup.find('input[name="logItemType"]').val(itemType);
        removePopup.find('input[name="completionDate"]').val(completionDate);
        removePopup.parent().addClass('visible');
    });
    logItemEditBtn.on('click', function () {
        var logItem = $(this).closest('.history__log-item');
        var id = logItem.attr('data-id');
        var itemType = logItem.attr('data-type');
        var completionDate = logItem.attr('data-completion-date');
        $.ajax({
            url: 'historik/redigera',
            data: { id: id, historyItemType: itemType, completionDate: completionDate }
        }).done(function (response) {
            $('#history-edit-popup').parent().replaceWith(response);
            initPopupCloseFunction();
            initCompletionDropdowns();
            initIsCompletedChangeListener();
            initPlannedCompletionDateChangeListener();
            $('#history-edit-popup').parent().addClass('visible');
        });
    });
    function initCompletionDropdowns() {
        var $years = $('.js-planned-completion-date').find('[data-role=\'year\']');
        var $months = $('.js-planned-completion-date').find('[data-role=\'month\']');
        var isCompleted = $('input[type=radio][name=IsCompleted]').filter(':checked').first().val() === 'True';
        handleStatusChange(isCompleted, $years, $months);
    }
});
